import { oc } from '@orpc/contract';
import { createVehicleInputSchema, vehicleSchema } from '../schemas/vehicles.schemas.js';
export const createVehicleContract = oc
    .route({
    method: 'POST',
    path: '/vehicles',
    tags: ['Vehicles'],
    summary: 'Add a vehicle to the catalogue',
    description: 'MANAGER only. Vehicle codes are unique.',
})
    .input(createVehicleInputSchema)
    .output(vehicleSchema);
//# sourceMappingURL=create-vehicle.contract.js.map